var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-title',[_c('h2',[_vm._v("Lista ofert")])]),_c('BidderOfferList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }